export class APIBasicConfig {
   base_url: string = 'https://backend-appraisal.jobsingta.com/api/';
  // base_url: string = 'http://localhost:3000/api/';
  //base_url: string = "http://34.54.147.148/api/";
}
